import type { API } from 'chessboard/api/config/types';
import type { Markings } from 'chessboard/plugins/markings/config/types';
import { toArray } from 'utils/array/to-array';
import { Core } from 'chessboard/core/config/types';
import { handleMark, handleUnmark } from 'chessboard/plugins/markings/handlers';
import { createMarkingsService } from 'chessboard/plugins/markings/service';

/**
 * Create the markings API.
 */
export function markingsAPI(context: API.Context): Markings.API {
  const { respond } = context;

  return createMarkingsService({
    onMarkingAdded: (addedMarkings) => respond(Core.APIEvents.Mark, toArray(addedMarkings)),
    onMarkingRemoved: (removedMarkings) => respond(Core.APIEvents.Unmark, toArray(removedMarkings)),
    onMarkingAddedToAlternateNode: (addedMarkings) =>
      handleMark({ data: toArray(addedMarkings) } as Core.Event, context, {
        includeAlternateNodes: true,
      }),
    onMarkingRemovedFromAlternateNode: (removedMarkings) =>
      handleUnmark({ data: toArray(removedMarkings) } as Core.Event, context, {
        includeAlternateNodes: true,
      }),
    context,
  });
}
